import { render, staticRenderFns } from "./UploadName.vue?vue&type=template&id=582bbb21&scoped=true&"
import script from "./UploadName.vue?vue&type=script&lang=js&"
export * from "./UploadName.vue?vue&type=script&lang=js&"
import style0 from "./UploadName.vue?vue&type=style&index=0&id=582bbb21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582bbb21",
  null
  
)

export default component.exports